import SkeletonGrid from "./skeleton-grid.component";

export default SkeletonGrid;
